import React, { Component } from "react";
import IntroSection from "components/intro-section/IntroSection";
import "./Europa.scss";
import SGI from "img/SGI-Europa.jpg";
import EurEau from "img/EurEau.png";
import IWA from "img/IWA.jpg";
import MWE from "img/MWE.jpg";
import CEWEP from "img/CEWEP.png";
import ISWA from "img/ISWA.png";
import CEDEC from "img/CEDEC.jpg";
import Eurelectric from "img/eurelectric.jpg";
import EFFS from "img/EFFS.png";
import ICF from "img/ICF.png";
import { ReactComponent as SquareOut } from "icons/square-out.svg";

const format = (title) => {
  let arr = [];
  let exludeWords = ["e", "di"];
  arr = title.split("-");
  return arr
    .map((word, i) => {
      return exludeWords.includes(word) && i !== 0
        ? [word]
        : word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
};

const boxInputs = [
  {
    title: "Associazione Europea delle imprese che gestiscono servizi pubblici",
    body: "SGI Europe rappresenta le imprese che gestiscono servizi pubblici davanti alle istituzioni europee, supportando la Commissione Europea, così come il Consiglio Europeo e il Parlamento Europeo, su qualsiasi proposta legislativa che abbia un impatto sui Servizi di Interesse Generale e sul loro ruolo nel Mercato Interno. SGI Europe realizza inoltre progetti che promuovono l'importanza dei servizi pubblici in Europa.",
    color: "#016fc0",
    img: SGI,
    referentName: "Luigi Joseph Del Giacco",
  },
  {
    title: "Associazione europea dei gestori di servizi idrici",
    body: "EurEau è la Federazione Europea delle Associazioni Nazionali dei Servizi Idrici e rappresenta i gestori nazionali dei servizi di acque potabili e reflue di 29 paesi, sia del settore pubblico che privato. Realizzano documenti di posizionamento dell'industria idrica europea in merito alla gestione della qualità dell'acqua, all'efficienza delle risorse e all'accesso all'acqua per i cittadini e le imprese.",
    color: "#016fc0",
    img: EurEau,
    referentName: "Luigi Joseph Del Giacco",
  },
  {
    title: "Associazione Internazionale dell’acqua",
    body: "IWA è l’Associazione Internazionale dell’Acqua, i cui membri sono dislocati in 140 paesi in tutto il mondo, formando la più grande rete internazionale di professionisti dell'acqua. Realizzano programmi e sviluppano ricerche e progetti incentrati su soluzioni per la gestione sostenibile delle acque e delle acque reflue.",
    color: "#016fc0",
    img: IWA,
    referentName: "Tania Tellini",
  },
  {
    title: "Associazione Europea dei rifiuti urbani",
    body: "Municipal Waste Europe è l'associazione europea che racchiude le associazioni pubbliche nazionali dei rifiuti, promuovendo gli interessi dei suoi membri a livello europeo attraverso documenti su questioni tecniche e legislative sulla gestione dei rifiuti, tenendo informati i suoi membri sugli sviluppi politici dell'UE. Realizzano documenti di posizionamento della filiera dei rifiuti in merito alla loro gestione sostenibile, dalla raccolta al trattamento, in un’ottica di economia circolare.",
    color: "#016fc0",
    img: MWE,
    referentName: "Bernardo Piccioli Fioroni",
  },
  {
    title: "Confederazione europea degli impianti di termovalorizzazione",
    body: "Il CEWEP è l'associazione dei gestori degli impianti di termovalorizzazione (incenerimento con recupero energetico), in rappresentanza di circa 410 impianti provenienti da 23 paesi. Costituiscono oltre l'80% della capacità di termovalorizzazione in Europa. Fornisce al pubblico informazioni sui livelli di emissione, sull'efficienza energetica, sulla tecnologia di termovalorizzazione e sul contributo degli impianti alla protezione del clima, al fine di sensibilizzare i cittadini sul ruolo svolto dai termovalorizzatori nel processo di decarbonizzazione.",
    color: "#016fc0",
    img: CEWEP,
    referentName: "Riccardo Viselli",
  },
  {
    title: "Associazione internazionale dei rifiuti solidi",
    body: "L'Associazione internazionale dei rifiuti solidi è un'associazione non governativa, indipendente e senza fini di lucro, la cui mission è promuovere e sviluppare la gestione dei rifiuti in tutto il mondo come contributo allo sviluppo sostenibile e in un’ottica di circular economy.",
    color: "#016fc0",
    img: ISWA,
    referentName: "Bernardo Piccioli Fioroni",
  },
  {
    title: "Confederazione europea dei distributori di energia comunali",
    body: "CEDEC, la Federazione Europea delle Compagnie Energetiche Locali, rappresenta gli interessi di oltre 1500 aziende energetiche locali e regionali - per lo più pubbliche - che servono 85 milioni di clienti, con un fatturato annuo di 120 miliardi di € in dieci paesi europei paesi: Austria, Belgio, Francia, Germania, Italia, Paesi Bassi, Norvegia, Polonia, Svezia e Svizzera.",
    color: "#016fc0",
    img: CEDEC,
    referentName: "Fabrizio Falconi",
  },
  {
    title: "Unione dell’Industria elettrica",
    body: "Eurelectric è la federazione dell'industria elettrica europea che rappresenta il settore energetico in oltre 32 paesi europei, con oltre 3.500 aziende impegnate nella produzione, distribuzione e fornitura di energia. Ha una struttura di competenze composta da circa 30 gruppi di lavoro, supervisionati da cinque comitati. Tale struttura garantisce che il contributo ai posizionamenti di Eurelectric provenga da diverse centinaia di esperti attivi del settore.",
    color: "#016fc0",
    img: Eurelectric,
    referentName: "Fabrizio Falconi",
  },
  {
    title: "Federazione europea dei servizi funerari",
    body: "La Federazione Europea dei Servizi Funebri con oltre 100 membri in 29 paesi è focalizzata sul miglioramento continuo della professionalità in questo settore di attività. Il loro obiettivo è supportare i membri con tutte le questioni europee, tecniche e legislative, inerenti il settore funerario.",
    color: "#016fc0",
    img: EFFS,
    referentName: "Valeria Leotta",
  },
  {
    title: "Federazione internazionale di cremazione",
    body: "L'International Cremation Federation (ICF) è un'organizzazione internazionale senza scopo di lucro dedicata alla promozione della pratica della cremazione. La mission dell’ICF è fornire informazioni in merito alla cremazione – i meriti, visti, inter alia, dal punto di vista igienico, etico, economico ed estetico - e semplificare il processo di cremazione, garantendo il riconoscimento generale di questa pratica.",
    color: "#016fc0",
    img: ICF,
    referentName: "Valeria Leotta",
  },
];

export default class Europa extends Component {
  render() {
    return (
      <div className="europa-page">
        <IntroSection
          category={format(this.props.match.url.split("/")[1])}
          subsector={format(this.props.match.url.split("/")[2])}
        />
        <div className="container pad-mobile">
          <div className="title">
            <h1 style={{ marginBottom: 0 }}>Europa</h1>
          </div>
          <p>
            Utilitalia aderisce ad organismi europei e internazionali di settore
            attraverso cui si svolge l’attività di aggiornamento e monitoraggio
            delle policies europee. I referenti interni alla Federazione, con
            l’ausilio dei tecnici delle Aziende Associate, presidiando i tavoli
            delle Associazioni Europee attraverso i vari gruppi di lavoro
            settoriali.
          </p>

          <div
            className="box-container"
            //             style={{ backgroundColor: "#fff", padding: 16 }}
          >
            {boxInputs.map((input, i) => {
              return (
                <div className="box-row">
                  <div className="box-column" style={{ flex: 2 }}>
                    <img src={input.img} />
                    <div className="box-title">{input.title}</div>
                  </div>
                  <div className="box-column" style={{ flex: 3 }}>
                    <p>{input.body}</p>
                    <p style={{ marginTop: "2rem" }}>
                      {`Referente: `} <span> {input.referentName}</span>
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}
